import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageQuizSettings({ quizId }) {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function addQuiz(data) {
    return privateFetch.post(`/v1/admin/quiz/${quizId}/settings`, data);
  }

  // function updateQuiz(quizID, data) {
  //   return privateFetch.put(`/v1/admin/quiz/${quizId}/settings`, data);
  // }

  // function deleteQuiz(quizID) {
  //   return privateFetch.delete(`/v1/admin/quiz/${quizId}/settings`);
  // }

  function manageQuiz(data = {}) {
    // if (data?.id) {
    //   return updateQuiz(data.id, data);
    // }
    // if (data?.type === 'DELETE') {
    //   return deleteQuiz(data.topicID);
    // }

    return addQuiz(data);
  }

  return useMutation(manageQuiz, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
    },
  });
}

export default useManageQuizSettings;
